import { render, staticRenderFns } from "./AppointmentConfig.vue?vue&type=template&id=3f43584e&scoped=true&"
import script from "./AppointmentConfig.vue?vue&type=script&lang=js&"
export * from "./AppointmentConfig.vue?vue&type=script&lang=js&"
import style0 from "./AppointmentConfig.vue?vue&type=style&index=0&id=3f43584e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f43584e",
  null
  
)

export default component.exports